import useMedicalResultsActions from "../../../../../../components/medical-results/useMedicalResultsActions";

export default function useImagingStudiesActions({ subTabImageStudies, onChange, appointmentId, patientId, isPageModalHistory, otherResultRecords }) {
  return useMedicalResultsActions({
    options: subTabImageStudies?.optionsImageStudiesServices,
    records: subTabImageStudies?.appointmentHistoryImages,
    onChange, appointmentId, patientId, isPageModalHistory,
    subTabKey: "subTabImageStudies",
    recordsKey: "appointmentHistoryImages",
    examIdField: "imageExamId",
    examField: "imageExam",
    examHeader: "Estudio de Imagen",
    resultName: "Resultados de Estudios de Imágenes",
    endpointName: "imaging-result",
    otherResultRecords,
  });
}
